import React from "react";
import {
  WAREHOUSES_URL,
  DELETE_WAREHOUSE,
  SAVE_WAREHOUSE,
} from "../../../API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded";
import ItemValidationSchema from "@Utils/Validations/ItemValidationSchema";

function WarehousesListing() {
  const attributes = [
    { key: "warehouseName", label: "Warehouse Name", flex: 2 },
  ];

  const validationSchema = ItemValidationSchema(attributes[0].key,attributes[0].label);

  return (
    <GenericItemsListing
      items_URL={WAREHOUSES_URL}
      SAVE_Item={SAVE_WAREHOUSE}
      DELETE_Item={DELETE_WAREHOUSE}
      title="Warehouses"
      name="Warehouse"
      icon={<WarehouseRoundedIcon fontSize="large" color="white" />}
      attributes={attributes}
      validationSchema={validationSchema}
      uniqueId={"warehouseId"}
    />
  );
}

export default WarehousesListing;
